/**
 * @file start-mocks.ts
 *
 * Conditionally starts the MSW browser worker. Mocking is opt-in via the `useMocks`
 * runtime-config flag (resolved per environment from `config/*.cjson`), so the same
 * bundle can run against fixtures or the real commerce API by flipping one cjson value.
 */

import { USE_MOCKS } from '../../config';

/** Whether shop API requests should be served by MSW fixtures. */
export const useMocks = USE_MOCKS;

/**
 * Starts the MSW worker when mocking is enabled; a no-op otherwise. Unhandled
 * requests pass through to the network so real endpoints (auth, project, shop
 * bootstrap) keep working.
 *
 * @returns Resolves once the worker is ready (or immediately when disabled).
 */
export async function startMocks(): Promise<void> {
  if (!useMocks) {
    return;
  }
  const { worker } = await import('./browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
}
